import React from 'react'

export const ArrowLeft: React.FC = () => {
  return (
    <path d="M5.78125 7.75C5.625 7.90625 5.625 8.125 5.78125 8.28125L9.4375 11.9062C9.59375 12.0625 9.84375 12.0625 9.96875 11.9062L10.1875 11.6875C10.3438 11.5312 10.3438 11.3125 10.1875 11.1562L7 8L10.2188 4.875C10.3438 4.71875 10.3438 4.5 10.2188 4.34375L9.96875 4.125C9.84375 3.96875 9.59375 3.96875 9.4375 4.125L5.78125 7.75Z" />
  )
}

export default ArrowLeft
